/**
 *
 * Logout
 *
 */

import { mapGetters, mapActions } from 'vuex';

import { LANDING_PAGE } from '@/constants/routes';

export default {
  name: 'Logout',

  render: () => null,

  data() {
    return {};
  },

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    unLogin() {
      return this.userInfo.unLogin;
    },
  },

  methods: {
    ...mapActions({
      ma_logout: 'logout',
    }),

    async _logoutCreated() {
      await this.ma_logout();
      if (this.$route.query.redirect_uri) {
        window.location.href = this.$route.query.redirect_uri;
      } else {
        this.$router.push(LANDING_PAGE);
      }
    }
  },

  created() {
    this._logoutCreated();
  },
};
